
import { defineComponent, onMounted, inject, ref, provide } from 'vue'
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n/index";
import eventService from '@/core/services/EventService';
import DrawerFormGeneral from '@/views/tournaments/drawers/DrawerFormGeneral.vue';

import { errManager } from "@/core/config/Tools";
import moment from 'moment';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: "tournament-forms",
    props:{
        id: null
    },
    components: { DrawerFormGeneral },
    setup(props) {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        //const { id } = route.params
        const evento = inject<any>("evento")
        const loader = ref(false)
        const dialogForm = ref(false)
        const listForms = ref<any>([])
        const itemForm = ref<any>({});
        const DrawerFormGeneralRef = ref<InstanceType<typeof DrawerFormGeneral> | null>(null);

        //provide
        provide("dialogForm", dialogForm)

        const openDialogForm = (idform) => {
            if(idform.idform == 1 || idform.idform == 2){
                itemForm.value = idform;
                DrawerFormGeneralRef.value?.openDrawer();
            }else if (idform.idform == 3) {
                const currentRoute = route.fullPath;
                router.push({ name: 'planilla', query: { backto: btoa(currentRoute) } });
            } else if(idform.idform == 4){
                const currentRoute = route.fullPath;
                router.push({ name: 'tournament-sports', query: { backto: btoa(currentRoute) } });
            } else {
                if (idform.enabled) {
                    itemForm.value = idform
                    dialogForm.value = true;
                } else {
                    ElMessage({
                        message: 'Formulario aún no está disponible',
                        type: 'warning',
                        customClass: 'bg-light-warning',
                    })
                }
            }


        }

        const getForms = async () => {
            loader.value = true
            listForms.value = []
            eventService.getForms(props.id)
                .then((res) => {
                    listForms.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        // Función para formatear las fechas
        const formatDate = (date: string) => {
            let lang = localStorage.getItem('lang') || 'es'
            let ofs = lang == 'es' ? 'del' : 'of the'
            return moment(date).locale(lang).format(`D [de] MMMM [${ofs}] YYYY`);
        };

        const modalClosed = () => {
            itemForm.value = null
            getForms()
        }

        onMounted(() => {
            getForms()
        })

        return {
            t,
            evento,
            loader,
            itemForm,
            dialogForm,
            listForms,
            DrawerFormGeneralRef,

            //methods
            getForms,
            openDialogForm,
            formatDate,
            modalClosed
        }

    },
})
